import {
    ChartBinSize,
    ChartDefinition,
    ChartGroupByMode,
    ChartKey,
    ChartQueryParam,
    ChartRendererType,
    ChartTimerName,
    ChartTimerStatus
} from '@frontend/chart/types';
import { Application, Feature } from '@frontend/functionality/types';

import { PACKAGE_TIMERS_DURATION_CHART_ENDPOINT } from '../package-chart-endpoints';

export const VENDING_PACKAGE_TIMERS_DURATION_AUDIT_PENDING_BY_PRODUCT_LIST_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.VENDING_PACKAGE_TIMERS_DURATION_AUDIT_PENDING_BY_PRODUCT_LIST,
    chartType: ChartRendererType.LIST,
    endpoint: PACKAGE_TIMERS_DURATION_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.VENDING },
        { key: ChartQueryParam.FEATURE, value: Feature.RETURN_TRANSACTION },
        { key: ChartQueryParam.NAME, value: ChartTimerName.PACKAGE_AUDIT_PENDING },
        { key: ChartQueryParam.STATUS, value: ChartTimerStatus.STARTED },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }
    ],
    groupBy: ChartQueryParam.PRODUCT_ID,
    groupByMode: ChartGroupByMode.VALUE
};
